import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-gather-details',
  templateUrl: './gather-details.page.html',
  styleUrls: ['./gather-details.page.scss']
})
export class GatherDetailsPage implements OnInit {
  @Input() currentGather
  messageSupport =
  'Hola%2c+estoy+usando+GoDx+y+requiero+de+soporte+t%c3%a9cnico+en+el+m%c3%b3dulo+de+Historial+con+una+solicitud+de+Retiro+de+Muestra'

  constructor(
    private modalController: ModalController,
    public loadingController: LoadingController,
    public platform: Platform
  ) {}

  ngOnInit() {
    if (this.currentGather && this.currentGather.events && Array.isArray(this.currentGather.events)) {
      // Transformar nombres de eventos ANTES de ordenar
      this.currentGather.events.forEach(event => {
        event.event_name = this.transformEventName(event.event_name);
      });

      // Ordenar eventos cronológicamente considerando ID si las fechas conciden
      this.currentGather.events = this.currentGather.events.sort((a, b) => {
        // Eventos sin fecha van al final
        if (!a.date_exec || a.date_exec.length === 0) return 1;
        if (!b.date_exec || b.date_exec.length === 0) return -1;
        
        const dateA = this.parseDate(a.date_exec);
        const dateB = this.parseDate(b.date_exec);
        
        // Primero ordenar por fecha
        const dateComparison = dateA.getTime() - dateB.getTime();
        if (dateComparison !== 0) {
          return dateComparison; // Fechas diferentes
        }
        
        // Si existen fechas iguales,ordenar por ID
        return a.id - b.id;
      });
    }
  }

  hasValidDates(): boolean {
    if (!this.currentGather.horary || this.currentGather.horary.length === 0) {
      return false;
    }
    
    return this.currentGather.horary.some(horario => this.isValidDate(horario.date));
  }

  isValidDate(dateString: string): boolean {
    if (!dateString) return false;
    return dateString.includes('/') && dateString !== "Fecha no disponible";
  }

  formatDate(dateString: string): string {
    if (dateString && dateString.includes('/')) {
      const parts = dateString.split(' ');
      if (parts.length > 0) {
        return parts[0]; // Devuelve solo "DD/MM/YYYY"
      }
    }
    
    return dateString || 'Fecha no disponible';
  }

  async closeModal() {
    await this.modalController.dismiss()
  }

  private parseDate(dateString: string): Date {
    if (!dateString) return new Date(0);
    
    // Manejar formato DD/MM/YYYY
    if (dateString.includes('/')) {
      const parts = dateString.split(' ')[0].split('/'); // Solo la parte de fecha
      if (parts.length === 3) {
        return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
      }
    }
    
    // Fallback: conversión directa
    return new Date(dateString);
  }

  /**
   * Transforma nombres de eventos de seguimiento al nuevo formato
   * @param eventName - Nombre original del evento
   * @returns Nombre transformado
   */
  private transformEventName(eventName: string): string {
    if (!eventName) return '';
    
    const transformations = {
      'Detalles de seguimiento Uno': 'Seguimiento #1',
      'Detalles de seguimiento Dos': 'Seguimiento #2', 
      'Detalles de seguimiento Tres': 'Seguimiento #3',
      'Detalles de seguimiento Cuatro': 'Seguimiento #4',
      'Detalles de seguimiento Cinco': 'Seguimiento #5'
    };
    
    return transformations[eventName] || eventName;
  }
}
